import {
    Area,
    AreaChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import type { ROASResult } from "../api";

export function AdSpendRevenueChart({ data }: { data: ROASResult }) {
    const fmt = (n: number) =>
        n.toLocaleString(undefined, { style: "currency", currency: data.currency, maximumFractionDigits: 0 });
    return (
        <div className="bg-okiru-panel border border-okiru-muted/15 rounded-xl p-5 h-full min-h-0 flex flex-col">
            <div className="flex items-baseline justify-between mb-4">
                <h3 className="text-sm uppercase tracking-wide text-okiru-muted">Spend vs attributed revenue</h3>
                <div className="text-xs text-okiru-muted">{data.currency}</div>
            </div>
            <ResponsiveContainer width="100%" height="100%" className="flex-1 min-h-0">
                <AreaChart data={data.series} margin={{ top: 4, right: 4, bottom: 4, left: 0 }}>
                    <defs>
                        <linearGradient id="fillSpend" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#8a8175" stopOpacity={0.4} />
                            <stop offset="100%" stopColor="#8a8175" stopOpacity={0.0} />
                        </linearGradient>
                        <linearGradient id="fillRev" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#c08552" stopOpacity={0.55} />
                            <stop offset="100%" stopColor="#c08552" stopOpacity={0.0} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#2a241e" />
                    <XAxis dataKey="day" stroke="#8a8175" fontSize={11} tickMargin={8} />
                    <YAxis stroke="#8a8175" fontSize={11} tickFormatter={fmt} />
                    <Tooltip
                        contentStyle={{
                            background: "#1a1612",
                            border: "1px solid #3a322a",
                            borderRadius: 8,
                            color: "#f0e9df",
                        }}
                        formatter={(v: number, name: string) => [fmt(v), name]}
                    />
                    <Legend wrapperStyle={{ fontSize: 11, color: "#8a8175" }} />
                    <Area
                        type="monotone"
                        dataKey="spend"
                        name="Spend"
                        stroke="#8a8175"
                        strokeWidth={2}
                        fill="url(#fillSpend)"
                    />
                    <Area
                        type="monotone"
                        dataKey="revenue"
                        name="Attributed revenue"
                        stroke="#c08552"
                        strokeWidth={2}
                        fill="url(#fillRev)"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}
